export const OPEN_OFFER = 'OPEN_OFFER';
